<template>
  <RouterLink
    :to="to"
    class="bg-slate-100 leading-tight relative group aspect-video block w-full overflow-hidden rounded-lg min-h-[150px]">
    <slot />
  </RouterLink>
</template>
<script setup>
defineProps({
  to: { required: false },
});

import { RouterLink } from "vue-router";
</script>
